import { EventEmitter, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

export interface AutoZoomBox {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

@Injectable({
  providedIn: 'root',
})
export class PuzzleZoomService {
  public dontScale = false;
  public keyboardIsOpen = false;
  public autoZoom: EventEmitter<AutoZoomBox> = new EventEmitter<AutoZoomBox>();
  public zoomAndPrint: EventEmitter<null> = new EventEmitter<null>();
  public autoZoomEnabled = true;
  public autoPan: EventEmitter<AutoZoomBox> = new EventEmitter<AutoZoomBox>();
  public initialScale: EventEmitter<null> = new EventEmitter<null>();
  public initialized = false;
  public setKeyboardTimeout: number;

  public showWordLengths = false;

  constructor(private store: Store) {
    // Select autoZoomEnabled from store and subscribe to it.
    this.store
      .select((state) => state.puzzleGameState.autoZoomEnabled)
      .subscribe((val) => {
        // Default value: true
        this.autoZoomEnabled = val === undefined || val;
      });
  }

  /**
   * Warning: ZoomBox may be altered
   */
  public zoomIn(zoomBox: AutoZoomBox) {
    this.stopInitialAutoScaling();
    if (this.autoZoomEnabled) {
      this.autoZoom.emit(zoomBox);
    }
  }

  /**
   * Zoom out depending on the settings minAutoZoomOut[Mobile]
   */
  public zoomOut() {
    if (this.autoZoomEnabled) {
      // Zoom out depending on the settings minAutoZoomOut[Mobile]
      this.autoZoom.emit({
        top: -1,
        right: -1,
        bottom: -1,
        left: -1,
      });
    }
  }

  /**
   * Zoom to the full board
   */
  public zoomFullBoard() {
    // Zoom to full board
    this.autoZoom.emit(null);
  }

  public setKeyboardOpen(open: boolean) {
    if (this.setKeyboardTimeout) {
      clearTimeout(this.setKeyboardTimeout);
      this.setKeyboardTimeout = undefined;
    }
    this.setKeyboardTimeout = window.setTimeout(() => {
      this.keyboardIsOpen = open;
      this.setKeyboardTimeout = undefined;
    }, 100);
  }

  /**
   * Stops the viewport related scaling, allows only zooming from now on.
   */
  public stopInitialAutoScaling() {
    this.dontScale = true;
  }
  public enableInitialAutoScaling() {
    this.dontScale = false;
  }

  ensureCursorInZoomArea(zoomBox: AutoZoomBox) {
    this.autoPan.emit(zoomBox);
  }
}
